import React from 'react';
import { DefaultPropertyType } from '../../../../../interface/core';
import Styles from './index.module.scss';
import { useTranslation } from 'react-i18next';


type InfoTablePropsType = {
  data: Array<DefaultPropertyType>
}

const InfoTable: React.FC<InfoTablePropsType> = ({
  data
}) => {
  const { t } = useTranslation();

  return (

    <table className={Styles.infoTable}>
      <tbody>
        {data.map((item, index) => {
          return (
            <tr key={index}>
              <td>{item.value}</td>
              <td className={Styles.text}>{item.label === 'Delivered' ? t("KLR02600") : item.label}</td>
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}
export default InfoTable;

